import { CryptoJsService } from './../../services/crypto-js.service';
import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/internal/operators/first';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Message, MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import * as CryptoJS from 'crypto-js';
import { MenuService } from 'src/app/services/app.menu.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';


@Component({
  selector: 'phone-login',
  templateUrl: './phone-login.component.html',
  styleUrls: ['./phone-login.component.scss']
})
export class PhoneLoginComponent implements OnInit {
  isOTPSend: boolean = false;
  phoneNo: string;
  otp: string;
  public onAuthForm: FormGroup;
  submitted: boolean;
  validationOTP: any;
  btnDisabled: boolean = false;
  display: any;

  constructor(
    private authService: AuthenticationService,
    private service: MessageService,
    private _formBuilder: FormBuilder,
    public router: Router,
    private farmersDetailsService: FarmersDetailsService,
    private cryptoJS: CryptoJsService,
    private menuService : MenuService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService
  ) { }

  ngOnInit(): void {
    this.onAuthForm = this._formBuilder.group({
      phoneNo: ['', [Validators.required]],
      otp: ['', [Validators.required]],
    });
    this.f.otp.disable();
  }

  get f() {
    return this.onAuthForm.controls;
  }

  onOTPClick() {
    if (!this.f.phoneNo.value) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Mobile Number Cant be Empty.' });
      return;
    }
    if(this.f.phoneNo.value.length < 10){
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Mobile Number Cant be Less than 10 Digits.' });
      return;
    }
    this.disableOTPButton(2);
    this.loader.start();
    this.authService.getOTP(JSON.stringify(this.cryptoJS.Encrypt(this.f.phoneNo.value)))
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data == 'Already Sent OTP to Mobile Number!') {
            this.f.otp.enable();
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Already Sent OTP to Mobile Number!' });
            return;
          }
          let otpData = data.toString().split(',');
          if (otpData.length > 0) {
            otpData = otpData[0].toString().split(':');
          }
          this.validationOTP = otpData[1].trim();
          this.f.otp.enable();
          this.service.add({ severity: 'success', summary: 'Success Message', detail: 'OTP Generated Successfully!' });
        },
        error: () => {
          this.loader.close();
          this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! OTP not generated.' });
        }
      });
  }

  disableOTPButton(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        console.log("finished");
        clearInterval(timer);
      }
    }, 1000);
  }

  login() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.onAuthForm.invalid) {
      this.activityRecordService.activityRecord(this.onAuthForm.controls.phoneNo.value, 'farmer_login', '', new Date(), 'Invalid Login');

      this.service.add({ severity: 'error', summary: 'Error Message', detail: "Invalid Input" });
      return;
    }
    let body = {
      "mobileNo": this.cryptoJS.Encrypt(this.onAuthForm.controls.phoneNo.value),
      "otp": this.cryptoJS.Encrypt(this.onAuthForm.controls.otp.value)
    }

    this.loader.start();
    this.authService.validateOTP(body).pipe(first())
      .subscribe({
        next: (data: any) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.onAuthForm.controls.phoneNo.value, 'farmer_login', '', new Date(), 'Success');

          if (data?.authToken) {
            window.sessionStorage.setItem("token", JSON.stringify(data));
            sessionStorage.setItem("auth_token", data?.authToken);
            sessionStorage.setItem("farmerPh", this.f.phoneNo.value);
            sessionStorage.setItem("userID", 'farmer');
            sessionStorage.setItem("isFarmerLogin", '1');
            // this.loader.start();
            this.farmersDetailsService.getFarmerDetails(this.f.phoneNo.value)
              .pipe(first())
              .subscribe({
                next: (data) => {
                  // this.loader.close();
                  if (data) {
                    window.sessionStorage.setItem("farmerDetails", JSON.stringify(data.Table[0]));
                    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
                    if (farmerData) {
                      // this.userName = farmerData.Name;
                      this.menuService.setUsername(farmerData.Name);
                    }
                  }
                },
                error: (err) => {
                  // this.loader.close();
                }
              });
            this.router.navigate(['/dashboard']);
          } else {
            this.activityRecordService.activityRecord(this.onAuthForm.controls.phoneNo.value, 'farmer_login', '', new Date(), 'OTP Validation Failed');

            this.service.add({ severity: 'error', summary: 'Error Message', detail: "OTP Validation Failed" });
          }
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.onAuthForm.controls.phoneNo.value, 'farmer_login', '', new Date(), err[0]);
          this.service.add({ severity: 'error', summary: 'Error Message', detail: "OTP Validation Failed" });
        }
      });
  }

}
